import './index.scss';
import logo from 'assets/images/logo.png';

export const Logo = () => (
	<div className="spa__logo">
		<img src={logo} alt="SPAGO" />
	</div>
);
